/**
 * Cart Drawer functionality
 */
theme.CartDrawer = (function() {
  var selectors = {
    cartDrawer: '[data-cart-drawer]',
    cartDrawerOverlay: '[data-cart-drawer-overlay]',
    cartDrawerClose: '[data-cart-drawer-close]',
    cartDrawerContent: '[data-cart-drawer-content]',
    cartDrawerItems: '[data-cart-drawer-items]',
    cartDrawerForm: '[data-cart-drawer-form]',
    cartDrawerEmpty: '[data-cart-drawer-empty]',
    cartDrawerCount: '[data-cart-drawer-count]',
    cartItem: '[data-cart-item]',
    cartRemove: '[data-cart-remove]',
    quantityInput: '[data-quantity-input]',
    quantityIncrease: '[data-quantity-increase]',
    quantityDecrease: '[data-quantity-decrease]',
    cartSubtotal: '[data-cart-subtotal]',
    cartNotes: '[data-cart-notes]'
  };

  var classes = {
    isOpen: 'is-open',
    isVisible: 'is-visible',
    isLoading: 'is-loading',
    hidden: 'hide'
  };

  var drawerInstance = null;
  var cartDrawerInstance = null;
  var isOpen = false;

  function CartDrawer() {
    this.$drawer = $(selectors.cartDrawer);
    this.$overlay = $(selectors.cartDrawerOverlay);
    this.$close = $(selectors.cartDrawerClose);
    this.$content = $(selectors.cartDrawerContent);
    this.$items = $(selectors.cartDrawerItems);
    this.$form = $(selectors.cartDrawerForm);
    this.$empty = $(selectors.cartDrawerEmpty);
    this.$count = $(selectors.cartDrawerCount);

    if (!this.$drawer.length) {
      console.warn('Cart drawer element not found in DOM');
      return;
    }

    this.init();
  }

  CartDrawer.prototype.init = function() {
    this.bindEvents();
    this.initDrawer();
  };

  CartDrawer.prototype.initDrawer = function() {
    var self = this;
    // Initialize drawer using theme.Drawers if available
    if (typeof theme.Drawers !== 'undefined') {
      drawerInstance = new theme.Drawers('CartDrawer', 'right', {
        onDrawerOpen: function() {
          isOpen = true;
          $('body').addClass('cart-drawer-open');
        },
        onDrawerClose: function() {
          isOpen = false;
          $('body').removeClass('cart-drawer-open');
        }
      });
    }
  };

  CartDrawer.prototype.bindEvents = function() {
    var self = this;

    // Close button
    this.$close.on('click', function() {
      self.close();
    });

    // Overlay click
    this.$overlay.on('click', function() {
      self.close();
    });

    // ESC key
    $(document).on('keyup.cartDrawer', function(e) {
      if (e.keyCode === 27 && isOpen) {
        self.close();
      }
    });

    // Remove item
    this.$drawer.on('click', selectors.cartRemove, function(e) {
      e.preventDefault();
      var $item = $(this).closest(selectors.cartItem);
      var itemKey = $item.data('cart-item-key');
      self.removeItem(itemKey, $item);
    });

    // Quantity controls
    this.$drawer.on('click', selectors.quantityIncrease, function() {
      var $input = $(this).siblings(selectors.quantityInput);
      var currentVal = parseInt($input.val()) || 0;
      $input.val(currentVal + 1).trigger('change');
    });

    this.$drawer.on('click', selectors.quantityDecrease, function() {
      var $input = $(this).siblings(selectors.quantityInput);
      var currentVal = parseInt($input.val()) || 0;
      if (currentVal > 1) {
        $input.val(currentVal - 1).trigger('change');
      }
    });

    // Quantity input change
    this.$drawer.on('change', selectors.quantityInput, function() {
      var $item = $(this).closest(selectors.cartItem);
      var itemKey = $item.data('cart-item-key');
      var quantity = parseInt($(this).val()) || 0;
      self.updateQuantity(itemKey, quantity, $item);
    });

    // Cart notes change
    this.$drawer.on('change', selectors.cartNotes, debounce(500, function() {
      self.updateCartNote();
    }));
  };

  CartDrawer.prototype.open = function() {
    var self = this;
    
    // Check if drawer element exists
    if (!this.$drawer || !this.$drawer.length) {
      console.error('Cart drawer element not found');
      return;
    }

    // If already open, just refresh the cart and return
    if (isOpen) {
      this.loadCart();
      return;
    }

    // Open drawer immediately (visual feedback)
    if (drawerInstance && typeof drawerInstance.open === 'function') {
      drawerInstance.open();
    } else {
      // Fallback if Drawers class not available - open immediately
      if (this.$drawer && this.$drawer.length) {
        this.$drawer.addClass(classes.isOpen);
        if (this.$overlay && this.$overlay.length) {
          this.$overlay.addClass(classes.isVisible);
        }
        $('body').addClass('cart-drawer-open');
        isOpen = true;
        
        // Focus trap
        if (typeof slate !== 'undefined' && slate.a11y && slate.a11y.trapFocus) {
          slate.a11y.trapFocus({
            $container: this.$drawer,
            namespace: 'cartDrawerFocus'
          });
        }
      }
    }
    
    // Load cart content (this will update the drawer content)
    this.loadCart();
  };

  CartDrawer.prototype.close = function() {
    if (!isOpen) return;

    if (drawerInstance && typeof drawerInstance.close === 'function') {
      drawerInstance.close();
    } else {
      // Fallback if Drawers class not available
      this.$drawer.removeClass(classes.isOpen);
      this.$overlay.removeClass(classes.isVisible);
      $('body').removeClass('cart-drawer-open');
      isOpen = false;
      
      // Remove focus trap
      if (typeof slate !== 'undefined' && slate.a11y && slate.a11y.removeTrapFocus) {
        slate.a11y.removeTrapFocus({
          $container: this.$drawer,
          namespace: 'cartDrawerFocus'
        });
      }
    }
  };

  CartDrawer.prototype.loadCart = function() {
    var self = this;
    
    // Get cart via AJAX
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) {
        self.renderCart(cart);
      },
      error: function() {
        console.error('Failed to load cart');
      }
    });
  };

  CartDrawer.prototype.renderCart = function(cart) {
    var self = this;

    if (cart.item_count === 0) {
      this.showEmpty();
      return;
    }

    this.hideEmpty();

    // Get cart HTML via AJAX
    $.ajax({
      url: '/cart',
      dataType: 'html',
      success: function(html) {
        var $html = $(html);
        var $cartItems = $html.find('[data-cart-line-items]');
        
        if ($cartItems.length) {
          // Extract cart items HTML
          var itemsHTML = '';
          $cartItems.find('[data-cart-item]').each(function() {
            var $item = $(this);
            var itemHTML = self.convertCartItemToDrawerItem($item);
            itemsHTML += itemHTML;
          });
          
          self.$items.html(itemsHTML);
        } else {
          // Fallback: build items from cart JSON
          self.buildItemsFromJSON(cart);
        }

        // Update cart count
        self.updateCartCount(cart.item_count);
        
        // Update header cart count
        self.updateHeaderCartCount(cart.item_count);
        
        // Update subtotal
        self.updateSubtotal(cart.total_price);
      },
      error: function() {
        // Fallback: build items from cart JSON
        self.buildItemsFromJSON(cart);
        self.updateCartCount(cart.item_count);
        self.updateHeaderCartCount(cart.item_count);
        self.updateSubtotal(cart.total_price);
      }
    });
  };

  CartDrawer.prototype.convertCartItemToDrawerItem = function($cartItem) {
    var itemKey = $cartItem.data('cart-item-key');
    var itemTitle = $cartItem.data('cart-item-title') || $cartItem.find('[data-cart-item-title]').text().trim();
    var itemUrl = $cartItem.data('cart-item-url') || $cartItem.find('a[href*="/products/"]').attr('href');
    var itemImage = $cartItem.find('[data-cart-item-image]').attr('src') || '';
    var itemQuantity = parseInt($cartItem.data('cart-item-quantity')) || 1;
    var itemPrice = $cartItem.find('[data-cart-item-final-price]').text() || '';
    var itemOriginalPrice = $cartItem.find('[data-cart-item-original-price]').text() || '';
    var hasDiscount = itemOriginalPrice && itemOriginalPrice.trim() !== '';
    
    var variantsHTML = '';
    $cartItem.find('[data-cart-item-option]').each(function() {
      variantsHTML += '<li class="cart-drawer__item-variant">' + $(this).text() + '</li>';
    });

    var priceHTML = '';
    if (hasDiscount) {
      priceHTML = '<span class="cart-drawer__item-price-original">' + itemOriginalPrice + '</span>' +
                  '<span class="cart-drawer__item-price-final">' + itemPrice + '</span>';
    } else {
      priceHTML = '<span class="cart-drawer__item-price-final">' + itemPrice + '</span>';
    }

    var itemHTML = '<div class="cart-drawer__item" ' +
                   'data-cart-item ' +
                   'data-cart-item-key="' + itemKey + '" ' +
                   'data-cart-item-url="' + itemUrl + '" ' +
                   'data-cart-item-title="' + itemTitle + '" ' +
                   'data-cart-item-quantity="' + itemQuantity + '">' +
                   '<div class="cart-drawer__item-image">' +
                   '<a href="' + itemUrl + '">' +
                   '<img src="' + itemImage + '" alt="' + itemTitle + '" width="120" height="120" loading="lazy" data-cart-item-image>' +
                   '</a>' +
                   '</div>' +
                   '<div class="cart-drawer__item-details">' +
                   '<div class="cart-drawer__item-title-wrapper">' +
                   '<a href="' + itemUrl + '" class="cart-drawer__item-title" data-cart-item-title>' + itemTitle + '</a>' +
                   '<button type="button" class="cart-drawer__item-remove" aria-label="Remove" data-cart-remove data-cart-item-key="' + itemKey + '">' +
                   '<svg class="icon-close" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                   '<path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
                   '</svg>' +
                   '</button>' +
                   '</div>' +
                   (variantsHTML ? '<ul class="cart-drawer__item-variants">' + variantsHTML + '</ul>' : '') +
                   '<div class="cart-drawer__item-price-wrapper">' +
                   '<div class="cart-drawer__item-price">' + priceHTML + '</div>' +
                   '<div class="cart-drawer__item-quantity">' +
                   '<div class="cart-drawer__quantity-controls">' +
                   '<button type="button" class="cart-drawer__quantity-btn cart-drawer__quantity-btn--minus" data-quantity-decrease aria-label="Decrease quantity">-</button>' +
                   '<input type="number" class="cart-drawer__quantity-input" value="' + itemQuantity + '" min="0" pattern="[0-9]*" data-quantity-input data-cart-item-key="' + itemKey + '">' +
                   '<button type="button" class="cart-drawer__quantity-btn cart-drawer__quantity-btn--plus" data-quantity-increase aria-label="Increase quantity">+</button>' +
                   '</div>' +
                   '</div>' +
                   '</div>' +
                   '</div>' +
                   '</div>';

    return itemHTML;
  };

  CartDrawer.prototype.buildItemsFromJSON = function(cart) {
    var self = this;
    var itemsHTML = '';

    if (cart.items && cart.items.length > 0) {
      cart.items.forEach(function(item, index) {
        var itemKey = item.key;
        var itemTitle = item.product_title || item.title;
        var itemUrl = item.url || '/products/' + item.handle;
        var itemImage = item.image || '';
        var itemQuantity = item.quantity || 1;
        var moneyFormat = theme.moneyFormat || '${{amount}}';
        var itemPrice = (typeof theme.Currency !== 'undefined' && theme.Currency.formatMoney) 
          ? theme.Currency.formatMoney(item.final_price, moneyFormat)
          : '$' + (item.final_price / 100).toFixed(2);
        var itemOriginalPrice = item.original_price !== item.final_price 
          ? ((typeof theme.Currency !== 'undefined' && theme.Currency.formatMoney)
            ? theme.Currency.formatMoney(item.original_price, moneyFormat)
            : '$' + (item.original_price / 100).toFixed(2))
          : '';
        var hasDiscount = item.original_price !== item.final_price;

        var variantsHTML = '';
        if (item.variant_options && item.variant_options.length > 0) {
          item.variant_options.forEach(function(option) {
            variantsHTML += '<li class="cart-drawer__item-variant">' + option + '</li>';
          });
        }

        var priceHTML = '';
        if (hasDiscount) {
          priceHTML = '<span class="cart-drawer__item-price-original">' + itemOriginalPrice + '</span>' +
                      '<span class="cart-drawer__item-price-final">' + itemPrice + '</span>';
        } else {
          priceHTML = '<span class="cart-drawer__item-price-final">' + itemPrice + '</span>';
        }

        itemsHTML += '<div class="cart-drawer__item" ' +
                     'data-cart-item ' +
                     'data-cart-item-key="' + itemKey + '" ' +
                     'data-cart-item-url="' + itemUrl + '" ' +
                     'data-cart-item-title="' + itemTitle + '" ' +
                     'data-cart-item-quantity="' + itemQuantity + '">' +
                     '<div class="cart-drawer__item-image">' +
                     '<a href="' + itemUrl + '">' +
                     '<img src="' + itemImage + '" alt="' + itemTitle + '" width="120" height="120" loading="lazy" data-cart-item-image>' +
                     '</a>' +
                     '</div>' +
                     '<div class="cart-drawer__item-details">' +
                     '<div class="cart-drawer__item-title-wrapper">' +
                     '<a href="' + itemUrl + '" class="cart-drawer__item-title" data-cart-item-title>' + itemTitle + '</a>' +
                     '<button type="button" class="cart-drawer__item-remove" aria-label="Remove" data-cart-remove data-cart-item-key="' + itemKey + '">' +
                     '<svg class="icon-close" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                     '<path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
                     '</svg>' +
                     '</button>' +
                     '</div>' +
                     (variantsHTML ? '<ul class="cart-drawer__item-variants">' + variantsHTML + '</ul>' : '') +
                     '<div class="cart-drawer__item-price-wrapper">' +
                     '<div class="cart-drawer__item-price">' + priceHTML + '</div>' +
                     '<div class="cart-drawer__item-quantity">' +
                     '<div class="cart-drawer__quantity-controls">' +
                     '<button type="button" class="cart-drawer__quantity-btn cart-drawer__quantity-btn--minus" data-quantity-decrease aria-label="Decrease quantity">-</button>' +
                     '<input type="number" class="cart-drawer__quantity-input" value="' + itemQuantity + '" min="0" pattern="[0-9]*" data-quantity-input data-cart-item-key="' + itemKey + '">' +
                     '<button type="button" class="cart-drawer__quantity-btn cart-drawer__quantity-btn--plus" data-quantity-increase aria-label="Increase quantity">+</button>' +
                     '</div>' +
                     '</div>' +
                     '</div>' +
                     '</div>' +
                     '</div>';
      });
    }

    this.$items.html(itemsHTML);
  };

  CartDrawer.prototype.removeItem = function(itemKey, $item) {
    var self = this;
    
    $item.addClass(classes.isLoading);

    $.ajax({
      url: '/cart/change.js',
      method: 'POST',
      data: {
        id: itemKey,
        quantity: 0
      },
      dataType: 'json',
      success: function(cart) {
        $item.remove();
        self.updateCartCount(cart.item_count);
        self.updateSubtotal(cart.total_price);
        
        if (cart.item_count === 0) {
          self.showEmpty();
        }
        
        // Update cart count in header
        self.updateHeaderCartCount(cart.item_count);
      },
      error: function() {
        $item.removeClass(classes.isLoading);
        alert('Failed to remove item. Please try again.');
      }
    });
  };

  CartDrawer.prototype.updateQuantity = function(itemKey, quantity, $item) {
    var self = this;
    
    if (quantity <= 0) {
      this.removeItem(itemKey, $item);
      return;
    }

    $item.addClass(classes.isLoading);

    $.ajax({
      url: '/cart/change.js',
      method: 'POST',
      data: {
        id: itemKey,
        quantity: quantity
      },
      dataType: 'json',
      success: function(cart) {
        $item.removeClass(classes.isLoading);
        $item.data('cart-item-quantity', quantity);
        
        // Update item price if needed
        var cartItem = cart.items.find(function(item) {
          return item.key === itemKey;
        });
        
        if (cartItem) {
          var $priceEl = $item.find('[data-cart-item-final-price]');
          var moneyFormat = theme.moneyFormat || '${{amount}}';
          var newPrice = (typeof theme.Currency !== 'undefined' && theme.Currency.formatMoney)
            ? theme.Currency.formatMoney(cartItem.final_line_price, moneyFormat)
            : '$' + (cartItem.final_line_price / 100).toFixed(2);
          $priceEl.text(newPrice);
        }
        
        self.updateCartCount(cart.item_count);
        self.updateSubtotal(cart.total_price);
        
        // Update cart count in header
        self.updateHeaderCartCount(cart.item_count);
      },
      error: function() {
        $item.removeClass(classes.isLoading);
        alert('Failed to update quantity. Please try again.');
      }
    });
  };

  CartDrawer.prototype.updateCartNote = function() {
    var note = this.$form.find(selectors.cartNotes).val();
    
    $.ajax({
      url: '/cart/update.js',
      method: 'POST',
      data: {
        note: note
      },
      dataType: 'json'
    });
  };

  CartDrawer.prototype.updateCartCount = function(count) {
    if (this.$count.length) {
      this.$count.text('(' + count + ')');
    }
  };

  CartDrawer.prototype.updateSubtotal = function(totalPrice) {
    var moneyFormat = theme.moneyFormat || '${{amount}}';
    var formattedPrice = (typeof theme.Currency !== 'undefined' && theme.Currency.formatMoney)
      ? theme.Currency.formatMoney(totalPrice, moneyFormat)
      : '$' + (totalPrice / 100).toFixed(2);
    this.$drawer.find(selectors.cartSubtotal).text(formattedPrice);
  };

  CartDrawer.prototype.updateHeaderCartCount = function(count) {
    // Update cart count in header/minicart
    $('[data-cart-count]').text(count);
    $('[data-cart-count-bubble]').text(count);
    
    // Also update cart count in drawer
    this.updateCartCount(count);
  };

  CartDrawer.prototype.showEmpty = function() {
    this.$empty.removeClass(classes.hidden);
    this.$form.addClass(classes.hidden);
  };

  CartDrawer.prototype.hideEmpty = function() {
    this.$empty.addClass(classes.hidden);
    this.$form.removeClass(classes.hidden);
  };

  // Public API
  return {
    init: function() {
      if (!cartDrawerInstance) {
        cartDrawerInstance = new CartDrawer();
      }
    },
    open: function() {
      // Check if drawer element exists in DOM first
      var $drawer = $(selectors.cartDrawer);
      if (!$drawer.length) {
        console.error('Cart drawer element with selector [data-cart-drawer] not found in DOM');
        return;
      }
      
      // Ensure instance exists
      if (!cartDrawerInstance) {
        cartDrawerInstance = new CartDrawer();
      }
      
      // Check if drawer element exists in instance
      if (!cartDrawerInstance || !cartDrawerInstance.$drawer || !cartDrawerInstance.$drawer.length) {
        // Re-initialize if element not found in instance
        cartDrawerInstance = new CartDrawer();
      }
      
      if (cartDrawerInstance && typeof cartDrawerInstance.open === 'function') {
        try {
          cartDrawerInstance.open();
        } catch (e) {
          console.error('Error in cartDrawerInstance.open():', e);
        }
      } else {
        console.error('Cart drawer instance or open method not available');
      }
    },
    close: function() {
      if (cartDrawerInstance) {
        cartDrawerInstance.close();
      } else if (drawerInstance && typeof drawerInstance.close === 'function') {
        drawerInstance.close();
      }
    }
  };
})();

// Hook into add to cart process - Permanent solution
// This intercepts all cart add requests and opens the drawer automatically
(function() {
  // Function to open cart drawer
  function openCartDrawer() {
    setTimeout(function() {
      if (typeof theme !== 'undefined' && theme.CartDrawer) {
        // Ensure drawer is initialized
        if (typeof theme.CartDrawer.init === 'function') {
          theme.CartDrawer.init();
        }
        // Open drawer
        if (typeof theme.CartDrawer.open === 'function') {
          theme.CartDrawer.open();
        }
      }
    }, 250);
  }
  
  // Method 1: Override $.post to catch cart/add.js calls directly
  var originalPost = $.post;
  $.post = function(url, data, success, dataType) {
    // Check if this is a cart add request
    var isCartAdd = false;
    var urlString = '';
    
    if (typeof url === 'string') {
      urlString = url;
      isCartAdd = url.indexOf('/cart/add.js') !== -1;
    } else if (url && typeof url === 'object' && url.url) {
      urlString = url.url;
      isCartAdd = url.url.indexOf('/cart/add.js') !== -1;
    }
    
    if (isCartAdd) {
      // Wrap the success callback
      var originalSuccess = null;
      var args = Array.prototype.slice.call(arguments);
      
      // Determine which argument is the success callback
      if (typeof data === 'function') {
        originalSuccess = data;
        args[1] = function(response) {
          if (originalSuccess) originalSuccess(response);
          openCartDrawer();
        };
      } else if (typeof success === 'function') {
        originalSuccess = success;
        args[2] = function(response) {
          if (originalSuccess) originalSuccess(response);
          openCartDrawer();
        };
      } else if (url && typeof url === 'object' && typeof url.success === 'function') {
        originalSuccess = url.success;
        url.success = function(response) {
          if (originalSuccess) originalSuccess(response);
          openCartDrawer();
        };
      } else {
        // If no success callback, add one
        if (url && typeof url === 'object') {
          url.success = function(response) {
            openCartDrawer();
          };
        } else {
          args.push(function(response) {
            openCartDrawer();
          });
        }
      }
      
      return originalPost.apply(this, args);
    }
    
    // For non-cart requests, call original
    return originalPost.apply(this, arguments);
  };
  
  // Method 2: Listen for successful cart additions via AJAX events
  var cartAddFlag = false;
  
  $(document).on('ajaxSend', function(event, xhr, settings) {
    if (settings.url && typeof settings.url === 'string' && settings.url.indexOf('/cart/add.js') !== -1) {
      cartAddFlag = true;
    }
  });
  
  $(document).ajaxSuccess(function(event, xhr, settings) {
    if (cartAddFlag && settings.url && typeof settings.url === 'string' && settings.url.indexOf('/cart/add.js') !== -1) {
      cartAddFlag = false;
      
      // Check if response indicates success
      var isSuccess = false;
      try {
        var response = xhr.responseJSON || (xhr.responseText ? JSON.parse(xhr.responseText) : null);
        if (response && (response.id || response.variant_id || response.product_id)) {
          isSuccess = true;
        }
      } catch (e) {
        if (xhr.status === 200) {
          isSuccess = true;
        }
      }
      
      if (isSuccess || xhr.status === 200) {
        openCartDrawer();
      }
    }
  });
  
  // Reset flag on ajax error
  $(document).ajaxError(function(event, xhr, settings) {
    if (settings.url && typeof settings.url === 'string' && settings.url.indexOf('/cart/add.js') !== -1) {
      cartAddFlag = false;
    }
  });
  
  // Method 3: Hook into Shopify.getCart to catch cart updates after add
  if (typeof Shopify !== 'undefined' && Shopify.getCart) {
    var originalGetCart = Shopify.getCart;
    var lastCartItemCount = 0;
    var cartAddDetected = false;
    
    // Track initial cart count
    if (typeof Shopify.cart !== 'undefined' && Shopify.cart.item_count !== undefined) {
      lastCartItemCount = Shopify.cart.item_count;
    }
    
    Shopify.getCart = function(callback, cart) {
      var wrappedCallback = function(cartData) {
        // Call original callback first
        if (callback && typeof callback === 'function') {
          callback(cartData);
        }
        
        // Check if cart item count increased (indicating an add)
        if (cartData && cartData.item_count !== undefined) {
          if (cartData.item_count > lastCartItemCount) {
            cartAddDetected = true;
            lastCartItemCount = cartData.item_count;
            // Open drawer after cart update
            setTimeout(function() {
              openCartDrawer();
              cartAddDetected = false;
            }, 300);
          } else {
            lastCartItemCount = cartData.item_count;
          }
        }
      };
      
      return originalGetCart.call(this, wrappedCallback, cart);
    };
  }
  
  // Method 4: Hook into theme.Product._addItemToCart if it exists
  $(document).ready(function() {
    // Wait a bit for theme.Product to be available
    setTimeout(function() {
      if (typeof theme !== 'undefined' && theme.Product && theme.Product.prototype && theme.Product.prototype._addItemToCart) {
        var originalAddToCart = theme.Product.prototype._addItemToCart;
        theme.Product.prototype._addItemToCart = function(data) {
          var result = originalAddToCart.apply(this, arguments);
          
          // Hook into the promise if it returns one
          if (result && typeof result.done === 'function') {
            var originalDone = result.done;
            result.done = function(callback) {
              var wrappedCallback = function(item) {
                if (callback) callback(item);
                // Open drawer after successful add
                setTimeout(function() {
                  openCartDrawer();
                }, 300);
              };
              return originalDone.call(this, wrappedCallback);
            };
          }
          
          return result;
        };
      }
    }, 1000);
  });
})();

// Initialize on DOM ready
$(document).ready(function() {
  if (typeof theme !== 'undefined' && theme.CartDrawer) {
    theme.CartDrawer.init();
  }
  
  // Add click handler for cart icon in header
  $(document).on('click', '[data-cart-drawer-trigger]', function(e) {
    e.preventDefault();
    if (typeof theme !== 'undefined' && theme.CartDrawer && typeof theme.CartDrawer.open === 'function') {
      // Ensure drawer is initialized
      if (typeof theme.CartDrawer.init === 'function') {
        theme.CartDrawer.init();
      }
      theme.CartDrawer.open();
    } else {
      // Fallback to cart page if drawer not available
      window.location.href = $(this).attr('href');
    }
  });
});

// Also try to initialize when window loads (fallback)
$(window).on('load', function() {
  if (typeof theme !== 'undefined' && theme.CartDrawer && !cartDrawerInstance) {
    theme.CartDrawer.init();
  }
});

// Debounce helper function
function debounce(func, wait) {
  var timeout;
  return function() {
    var context = this;
    var args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      func.apply(context, args);
    }, wait);
  };
}

